export default {
  // Contact Labels
  contactLabel: "Contact",
  contactTitle: "Contactez-Nous",
  phoneLabel: "Téléphone",
  emailLabel: "Email",
  whatsappLabel: "WhatsApp",
  locationLabel: "Siège Social",
  callUs: "Appelez-Nous",

  // Navbar
  navHome: "Accueil",
  navAbout: "À Propos",
  navServices: "Services",
  navBusiness: "Investissement & Affaires",
  navTenders: "Appels d'Offres",
  navEvents: "Événements d'Investissement",
  navContact: "Contact",
  navGetInTouch: "Contactez-Nous",
  navLocation: "Kigali, Rwanda",
  navPhone: "+250 788 377 109 ",
  navWhatsApp: "WhatsApp",
  navEmail: "info@africainvestmentportal.com",
  navLinkedIn: "LinkedIn",
  navTwitter: "Twitter",

  // Footer
  footerTagline: "Votre partenaire de confiance pour l'investissement, la conformité et la facilitation des affaires en Afrique de l'Est.",
  footerServices: "Services",
  footerSectors: "Secteurs",
  footerCompany: "Entreprise",
  footerLegal: "Légal",
  footerCompanyRegistration: "Enregistrement d'Entreprise",
  footerRegulatoryCompliance: "Conformité Réglementaire",
  footerInvestmentFacilitation: "Facilitation de l'Investissement",
  footerTenderSupport: "Support d'Appels d'Offres",
  footerBusinessExpansion: "Expansion Commerciale",
  footerHealthPharma: "Santé & Pharma",
  footerEducation: "Éducation",
  footerAgriculture: "Agriculture",
  footerMining: "Mines",
  footerManufacturing: "Manufacture",
  footerAboutUs: "À Propos",
  footerEvents: "Événements",
  footerBusiness: "Affaires",
  footerContact: "Contact",
  footerPrivacyPolicy: "Politique de Confidentialité",
  footerTermsOfService: "Conditions d'Utilisation",
  footerCopyright: "© {year} Africa Investment Portal. Tous droits réservés.",
  footerLocation: "Kigali, Rwanda · Afrique de l'Est",
  footerAIP: "AIP",

  // Not Found
  notFoundTitle: "Cette page n'a pas été générée",
  notFoundPrompt: "Dites-moi en plus sur cette page, afin que je puisse la générer",

  // Language
  language: "Langue",
  en: "English",
  fr: "Français",

  // Generic
  learnMore: "En savoir plus",
  viewAll: "Voir tout",
  registerNow: "S'inscrire",
  submit: "Soumettre",
  cancel: "Annuler",
  close: "Fermer",
  back: "Retour",
  details: "Voir les détails",
  expressInterest: "Manifester un intérêt",
  startNow: "Commencer maintenant",
  processing: "Traitement en cours...",
  sent: "Envoyé!",
  clearFilters: "Effacer les filtres",
  filterBy: "Filtrer:",
  found: "trouvé",
  step: "Étape",
  why: "Pourquoi",
  days: "jours",
  avgRegistration: "Enregistrement moyen",
  minCapital: "Capital minimum",
  foreignOwnership: "Propriété étrangère",
  required: "*",
  fullName: "Nom complet",
  email: "Adresse email",
  phone: "Numéro de téléphone",
  company: "Entreprise",
  country: "Pays",
  sector: "Secteur",
  message: "Message",
  additionalInfo: "Informations complémentaires",
  selectCountry: "Sélectionnez un pays",
  selectSector: "Sélectionnez un secteur",
  successTitle: "Demande reçue!",
  successBody: "Notre équipe vous contactera dans les 24 heures pour guider vos prochaines étapes.",
  submitAnother: "Soumettre une autre demande",
  noResults: "Aucun résultat ne correspond à vos filtres",
  tryAdjusting: "Essayez d'ajuster votre sélection",
  readMore: "Lire la suite",
  loading: "Chargement...",
  contactUs: "Contactez-nous",
  exploreServices: "Explorer les services",
};